import { combineReducers } from 'redux';
import createWebStorage from "redux-persist/lib/storage/createWebStorage";
import { authSlice } from '../redux/slicers/auth';
import { userSlice } from '../redux/slicers/user';
import { appSlice } from '../redux/slicers/app';
import { notificationSlice } from '../redux/slicers/notify';

const createNoopStorage = () => {
  return {
    getItem(_key) {
      return Promise.resolve(null);
    },
    setItem(_key, value) {
      return Promise.resolve(value);
    },
    removeItem(_key) {
      return Promise.resolve();
    },
  };
};

const storage = typeof window !== "undefined" ? createWebStorage("local") : createNoopStorage();

const rootPersistConfig = {
  key: 'root',
  storage,
  keyPrefix: 'redux-',
  // whitelist: []
  whitelist: ['auth', 'user']
};

const rootReducer = combineReducers({
  auth: authSlice.reducer,
  user: userSlice.reducer,
  app: appSlice.reducer,
  notification: notificationSlice.reducer
});

export { rootPersistConfig, rootReducer };

